import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class KitApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getByKitId(
    id :number,
    params :{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/products/kits/items/${id}`,
      { params },
    );
  }
}
